import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { MarkerDataSystem } from "api/interfaces/dashboardInterface.interface";
import { MarkerDataType } from "../../GoogleMapContainer";
import { ItemOneRecorder } from "./listInfoItem/ItemOneRecorder";
import { ItemMultiRecorder } from "./listInfoItem/ItemMultiRecorder";
interface InfoViewProps {
  data: MarkerDataType;
  onSelectRecorder: (system: MarkerDataSystem) => void;
  cloudStatus: boolean;
}

export default function RecorderListInfoView(
  props: InfoViewProps
): JSX.Element {
  return (
    <Wrapper>
      <Info>
        <ul>
          {props.data.groupingSystems.map((system, idx) => {
            if (system.recorders && system.recorders.length > 1) {
              return (
                <ItemMultiRecorder
                  key={`info-view-${idx}`}
                  system={system}
                  onSelectRecorder={props.onSelectRecorder}
                  cloudStatus={props.cloudStatus}
                />
              );
            }

            return (
              <ItemOneRecorder
                system={system}
                key={`info-view-${idx}`}
                onSelectRecorder={props.onSelectRecorder}
                cloudStatus={props.cloudStatus}
              />
            );
          })}
        </ul>
      </Info>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: ${({ theme }) =>
    theme.value === "light" ? COLORS.WHITE : "#0d1119"};
  padding: 8px 0;
  min-width: max-content;
  width: max-content;
`;

const Info = styled.div`
  ${FLEX.FlexBetweenStart};
  flex-wrap: stretch;
  flex-direction: column;
  height: 100%;
  flex: 1;
  width: 280px;

  > ul {
    ${FLEX.FlexStartStart};
    flex-direction: column;
    flex: 1;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    padding: 0 12px;

    > li {
      &:last-child {
        border-bottom: none;
      }
    }
  }
`;
